import PropTypes from "prop-types";
import { Input } from "@vds/inputs";
import { ModalBody, ModalFooter, ModalTitle } from "@vds/modals";
import { Body, Title } from "@vds/typography";
import { useDispatch } from "react-redux";
import { updateUI } from "../../../../store/actions/asset";

function CreateAssetStep1(props) {
  const { formData, onExit } = props;
  const dispatch = useDispatch();
  const handleNext = () => {
    if (!formData?.step1?.assetName) {
      dispatch(
        updateUI({
          formData: {
            ...formData,
            step1: { ...formData.step1, errors: { assetName: true } },
          },
        })
      );
      return;
    }
    

    dispatch(updateUI({ formData: { ...formData, selectedStep: 2 } }));
  };

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    const trimmedValue = typeof value === "string" ? value.trimStart() : value; 
    let error = {};

    if (name in formData?.step1?.errors) {
      error[name] = false;
    }

    dispatch(
      updateUI({
        formData: {
          ...formData,
          step1: {
            ...formData.step1,
            errors: { ...formData.step1.errors, ...error },
            [name]: trimmedValue,
           // [name]: value,
          },
        },
      })
    );
  };
 
  return (
    <>
      <ModalTitle>
        <Body size="large">Add asset</Body>
        <div className="mt-2">
          <Title size="large" bold={true}>
            Asset details
          </Title>
        </div>
      </ModalTitle>
      <ModalBody>
        <div className="d-flex flex-column justify-content-center align-items-center gap-4">
          <Input
            type="text"
            label="Asset name"
            name="assetName"
            defaultValue={formData?.step1?.assetName}
            readOnly={false}
            required={true}
            disabled={false}
            error={formData?.step1?.errors?.assetName}
            errorText="Asset name is required."
            onChange={handleFieldChange}
          />
          <Input
            type="text"
            label="Description"
            name="description"
            defaultValue={formData?.step1?.description}
            readOnly={false}
            required={false}
            disabled={false}
            onChange={handleFieldChange}
          />
        </div>
      </ModalBody>
      <ModalFooter
        buttonData={{
          close: {
            width: "100%",
            children: "Next",
            onClick: handleNext,
          },
          primary: {
            children: "Cancel",
            width: "100%",
            onClick: onExit,
          },
        }}
      />
    </>
  );
}

CreateAssetStep1.propTypes = {
  formData: PropTypes.object.isRequired,
  onExit: PropTypes.func.isRequired,
};

export default CreateAssetStep1;
